<div class="container-fluid cw-background manage-view">
  <mat-card class="mat-elevation-z8 mt-5 mb-5" id="card">
    <div class="text-left go-back d-block">
      <button (click)="goBack()" disableRipple mat-button class="delete-user p-0">
        <mat-icon matPreffix>arrow_back_ios</mat-icon>
        Go Back
      </button>
      <h6 class="text-center card-title-page mb-4">Edit Asset:</h6>
    </div>
    <div class="row d-flex">
      <button *ngIf="canEditAsset()" (click)="toggleManageAsset()" class="edit" color="primary" mat-icon-button>
        <mat-icon>create</mat-icon><span class="mat-h3"> Edit</span>
      </button>
      <div class="col-12 col-sm-9 col-sm-offset-1">
        <app-dynamic-form
          *ngIf="questions"
          [questions]="questions"
          (hasChanged)="onChange($event)"
          [disabled]="!isEdit"
          (formSubmit)="onSubmit($event)"
        >
        </app-dynamic-form>

        <div class="form-group-button text-center mt-4">
          <button
            *ngIf="canDeleteAsset()"
            (click)="deleteAssetModal()"
            disableRipple
            mat-button
            class="form-group-button text-center"
          >
            <mat-icon matPreffix>delete</mat-icon>
            Delete asset
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid cw-background" *ngIf="assetId">
      <div class="row">
        <div class="col-12">
          <mat-tab-group [@.disabled]="true" (selectedTabChange)="onTabChange()">
            <mat-tab label="Contracts">
              <app-data-table
                *ngIf="contractTableConfig"
                [config]="contractTableConfig"
                (getData)="getContracts($event)"
              ></app-data-table>
            </mat-tab>
            <mat-tab label="Tickets">
              <app-data-table
                *ngIf="ticketTableConfig"
                [config]="ticketTableConfig"
                (getData)="getTickets($event)"
              ></app-data-table>
            </mat-tab>
            <mat-tab label="Attachments">
              <app-data-table
                *ngIf="asset"
                [config]="assetAttachmentsTableConfig"
                (getData)="getAssetAttachments($event)"
                (updateData)="assetAttachmentTableService.update($event)"
              ></app-data-table>
            </mat-tab>
            <mat-tab label="Attributes">
              <app-data-table
                #assetAttributesTable
                *ngIf="asset"
                [config]="assetAttributesTableConfig"
                (getData)="getAssetAttributes($event)"
                (updateData)="assetAttributeTableService.update($event)"
              ></app-data-table>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </mat-card>
</div>
